module.exports = __webpack_public_path__ + "static/media/bytt-no-4.7a7625f1.mp3";